<template>
<div class="common__main-contener">
  <div class="common__main-content">
    <div>
      <p class="explanation">
        <span class="mr-3">LANGX Score</span>
        <span class="mr-3">section 1: {{ value.wetec.first | formatdec }}</span>
        <span class="mr-3">section 2: {{ value.wetec.second | formatdec  }}</span>
        <span class="mr-3">section 3: {{ value.wetec.third | formatdec  }}</span>
        <span class="mr-3">section 4: {{ value.wetec.fourth | formatdec  }}</span>
        <span class="mr-3">section 5: {{ value.wetec.fifth | formatdec  }}</span>
        <span class="mr-3">section 6: {{ value.wetec.sixth | formatdec  }}</span>
        <span class="total-score">total: {{ value.wetec.total | formatdec  }}</span>
      </p>

      <div class="container-fluid criteria">
        <div class="row criteria-headers">
          <div class="col-2">Criteria</div>
          <div class="col-10">Ratings</div>
        </div>

        <div class="row criteria-body">

          <div class="row criterion w-100 mx-0"
            v-for="criterion of grade.criteria" :key="criterion.id">
            <div class="col-2 item">
              <ValidationProvider rules="required" v-slot="{ errors }">
              <div>{{ criterion.name }}</div>
              <div class="text-danger">{{ errors[0] }}</div>
              <input type="hidden" v-model="criterion.selectedRatingId">
              </ValidationProvider>
            </div>

            <div class="col-10">
              <div class="row ratings">
                <div v-for="rating in criterion.ratings" :key="rating.id"
                  class="col item" :class="{
                    'selected': rating.id === criterion.selectedRatingId,
                    'selectable': !isConfirm,
                  }"
                  @click="!isConfirm && (criterion.selectedRatingId = rating.id)">
                  <div>{{ rating.description }}</div>
                  <div v-show="rating.note">{{ rating.note }}</div>
                </div>
              </div>
            </div>
          </div>

        </div><!-- criteria-body -->

      </div><!-- .criteria -->

      <div class="notes mt-5">
        <p class="mb-0">Notes field</p>
        <textarea name="notes" cols="30" rows="10" v-model="grade.note" :disabled="isConfirm" />
      </div>
    </div>
  </div>
</div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ValidationProvider } from 'vee-validate'
import {
  Grade,
  StudentWithGrade,
  Rating,
  Criterion,
} from '@/store/lessons/classRecord/types'

@Component({
  components: {
    ValidationProvider,
  },
  filters: {
    formatdec(v: string|null): string {
      if (!v) return ''
      return parseFloat(v).toFixed(2)
    },
  },
})
export default class ClassRecordStudentRecord extends Vue {
  @Prop() private isConfirm!: boolean

  @Prop() private value!: StudentWithGrade

  private get grade(): Grade {
    return this.value.forEdit
  }

  private set grade(grade: Grade) {
    this.$emit('change', grade)
  }
}
</script>

<style lang="scss" scoped>
.explanation {
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 14px;
}

.criteria {
  margin: 0px;
  border: solid 3px #5B9BD5;

  .criteria-headers {
    background-color: #D0CECE;
    div {
      padding: 15px;
      font-weight: bold;
    }
    div:not(:last-child) {
      border-right: solid 2px #5B9BD5;
    }
  }

  .criteria-body {
    background-color: #F2F2F2;

    .item {
      padding: 15px;
      border-top: solid 2px #5B9BD5;
    }
    .item:not(:last-child) {
      border-right: solid 2px #5B9BD5;
    }

    .ratings {
      height: 100%;
    }

    .ratings .selectable:hover {
      background-color: #FEE6FC;
    }

    .ratings .item.selected {
      background-color: rgb(245, 116, 114);
    }
  }

}

.total-ponit {
  margin: 25px 10px;
  text-align: right;
  font-size: 14px;
}

.notes {
  p {
    font-size: 16px;
  }

  textarea {
    border-radius: 5px;
    border-style: none;
    background-color: white;
    margin: 5px 0px;
    width: 100%;
  }
}

.total-score {
  display: block;
  margin-left: 104px;
}

</style>
